module.exports = __webpack_public_path__ + "img/avatar_face.737ddc5a.png";